<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import notify from "../../../../Script/notify"

  export let Url = {}

  /**
   * @type {Boolean} whether to show passcode enter area are not
   */
  let toggleCard = false

  /**
   * @type {Boolean} whether the notice check box is checked are not
   */
  let noticeCheckbox

  /**
   * @type {Boolean} whether the NDA check box is checked are not
   */
  let NDACheckbox

  /**
   * @type {Boolean} To store the NDA Link
   */
  let NDAlink

  /**
   * @type {Boolean} To store the notice Link
   */
  let noticelink

  /**
   * @type {URLNotify}
   */
  let URLNotify = {
    close() {},
  }

  /**
   * @description Function dispatch the NDA url
   */
  const addNDA = async (e) => {
    if (!e.target.value) NDACheckbox = false
    URLNotify.close()
    if (Url.NDA) {
      try {
        NDAlink = await isValidLink(Url.NDA)
      } catch (error) {
        Url.NDA = ""
        const info = "PAGE: Secure Access\nEVENT: While validating the NDA URL on blur."
        URLNotify = notify.danger(error, info)
        NDACheckbox = false
      }
    }
    dispatch("output", Url)
  }

  /**
   * @description Function dispatch the notice url
   */
  const addNotice = async (e) => {
    if (!e.target.value) noticeCheckbox = false
    URLNotify.close()
    if (Url.notice) {
      try {
        noticelink = isValidLink(Url.notice)
      } catch (error) {
        Url.notice = ""
        noticeCheckbox = false
        const info = "PAGE: Secure Access\nEVENT: While validating the Notice URL on blur."
        URLNotify = notify.danger(error, info)
      }
    }
    dispatch("output", Url)
  }

  /**
   * @description Function for check the url is valid
   */
  const isValidLink = (link) => {
    try {
      const linkRegex = /^(https:\/\/|#|http:\/\/)/
      if (!linkRegex.test(link)) throw "Invalid URL Found"
      return link
    } catch (error) {
      throw error
    }
  }
</script>

<div class="group space-y-3">
  <button on:click={() => (toggleCard = !toggleCard)} class="flex w-full items-center justify-between {NDAlink || noticelink ? 'bg-green-500' : toggleCard ? 'bg-[#09f6e7]/50 ' : 'bg-slate-200  hover:bg-[#09f6e7]/50 dark:bg-[#212539] dark:hover:bg-[#09f6e7]/50'} rounded-md px-3 py-2 text-[#292a23] dark:text-[#09f6e7] sm:px-6 sm:py-4">
    <div class="flex select-none {NDAlink || noticelink || toggleCard ? 'text-white' : ''} items-center gap-3 text-sm font-semibold group-hover:text-white mobile:text-base">
      <i class="fa-solid fa-file-invoice hidden mobile:block" />
      <p>Secure by NDA / Notice</p>
    </div>
    <div class="flex items-center gap-3">
      {#if NDAlink || noticelink}
        <div class="text-base text-white mobile:right-14 mobile:text-2xl">
          <i class="fa-solid fa-shield-check" />
        </div>
      {:else}
        <div class="text-base {toggleCard ? 'text-white' : 'text-[#292a2f] dark:text-[#09f6e7]'} group-hover:text-white mobile:right-14 mobile:text-2xl">
          <i class="fa-solid fa-shield-exclamation" />
        </div>
      {/if}
      <!-- <ToggleSwitch bind:toggleCard disable={NDAlink || noticelink} /> -->
    </div>
  </button>
  {#if toggleCard}
    <div class="space-y-3 rounded-md p-3 shadow-md dark:bg-bodyblack mobile:p-6">
      <p class="select-none text-justify text-gray-800 dark:text-gray-200">Here you can secure the document by NDA / Notice.</p>
      <form on:submit|preventDefault|stopPropagation={(e) => addNDA(e)} class="space-y-3">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-3">
          <div class="flex w-full items-center gap-1 whitespace-nowrap sm:w-4/12 sm:gap-3">
            <input
              id="nda"
              disabled={!Url.NDA}
              bind:checked={NDACheckbox}
              on:click={() => {
                if (NDACheckbox) {
                  NDAlink = ""
                  Url.NDA = ""
                  dispatch("output", Url)
                }
              }}
              type="checkbox"
              readonly
              class="cursor-pointer"
            />
            <div class="w-full">
              <label for="nda" class="w-auto cursor-pointer select-none text-sm text-gray-200 sm:text-base">NDA URL</label>
            </div>
          </div>
          <div class="flex w-full items-center gap-3">
            <input
              on:click={() => (NDACheckbox = true)}
              bind:value={Url.NDA}
              on:blur={(e) => addNDA(e)}
              on:input={(e) => {
                if (!e.target.value) {
                  NDAlink = ""
                  NDACheckbox = false
                } else {
                  NDACheckbox = true
                }
              }}
              placeholder="Link your blockChain to secure NDA URL"
              type="text"
              name="NDA"
              class="h-[37.6px] w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 disabled:cursor-not-allowed dark:text-white sm:w-2/3 sm:text-sm"
            />
            <button type="button" class="text-gray-200" data-tooltip="Enter NDA URL" tooltip-position="top">
              <i class="fa-solid fa-circle-info" />
            </button>
          </div>
        </div>
      </form>
      <form on:submit|preventDefault|stopPropagation={(e) => addNotice(e)} class="space-y-3">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-3">
          <div class="flex w-full items-center gap-1 whitespace-nowrap sm:w-4/12 sm:gap-3">
            <input
              id="notice"
              disabled={!Url.notice}
              bind:checked={noticeCheckbox}
              on:click={() => {
                if (noticeCheckbox) {
                  noticelink = ""
                  Url.notice = ""
                  dispatch("output", Url)
                }
              }}
              type="checkbox"
              class="cursor-pointer"
            />
            <div class="w-full sm:w-4/12">
              <label for="notice" class="w-auto cursor-pointer select-none text-sm text-gray-200 sm:text-base">Notice URL</label>
            </div>
          </div>
          <div class="flex w-full items-center gap-3">
            <input
              on:click={() => (noticeCheckbox = true)}
              bind:value={Url.notice}
              on:blur={(e) => addNotice(e)}
              on:input={(e) => {
                if (!e.target.value) {
                  noticelink = ""
                  noticeCheckbox = false
                } else {
                  noticeCheckbox = true
                }
              }}
              placeholder="Link your blockChain to secure notice URL"
              type="text"
              name="NDA"
              class="h-[37.6px] w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 disabled:cursor-not-allowed dark:text-white sm:w-2/3 sm:text-sm"
            />
            <button type="button" class="text-gray-200" data-tooltip="Enter notice URL" tooltip-position="top">
              <i class="fa-solid fa-circle-info" />
            </button>
          </div>
        </div>
      </form>
    </div>
  {/if}
</div>
